import waves from './waves'
// 按钮水波纹点击效果

const install = (Vue) => {
  Vue.directive('waves', waves)
};

if (window.Vue) {
  window.waves = waves;
  Vue.use(install); // eslint-disable-line
}

waves.install = install;
export default waves



// WEBPACK FOOTER //
// ./src/directive/waves/index.js